// extracted by mini-css-extract-plugin
module.exports = {"Videos":"Videos_Videos__1W5bn","Header":"Videos_Header__1ReHK"};